<template>
<div class="mailbox-detail">
  <div class="message-nav flex">
    <ArrowLeftIcon
      class="icon"
      @click="$emit('backDel')"/>
    <TrashIcon
      class="icon" @click="deleteMessage" />
  </div>
  <div class="title-snip flex">
    <h3>{{ message.title }}</h3>
    <span>{{ message.createdAt.toDate().toLocaleDateString('en-us', dateOptions) }}</span>
  </div>
  <div v-if="message.name">
    <h4>{{ message.prenom }}. {{ message.name }}</h4>
    <span>{{ message.email }}</span> | <span>{{ message.phone }}</span>
  </div>
  <p>{{ message.message }}</p>
</div>
</template>

<script>
import { db, doc, deleteDoc } from '@/firebase/config'
import { ref } from '@vue/reactivity'
import { ArrowLeftIcon, TrashIcon } from '@heroicons/vue/outline'
export default {
  components: { ArrowLeftIcon, TrashIcon },
  props: ['message'],
  emits: ['backDel'],
  setup (props, context) {
    const dateOptions = ref({ year: 'numeric', month: 'short', day: 'numeric' })

    const deleteMessage = async () => {
      await deleteDoc(doc(db, '/schools/inspire-schools/' + props.message.grade + '/messages/' + props.message.role, props.message.id))
      context.emit('backDel')
    }
    return { deleteMessage, dateOptions }
  }
}
</script>

<style>
  .mailbox-detail {
    position: relative;
    background: white;
    min-height: 300px;
  }
  .mailbox-detail h3 {
      color: black;
    }
  .mailbox-detail p {
      margin: 5px auto;
      padding-top: 50px;
      font-size: 1.6em;
      width: 90%;
    }
  .mailbox-detail .card {
    background: white;
    width: 95%;
    margin: 10px auto;
    cursor: pointer;
    border-radius: 15px;
  }
  .mailbox-detail .title-snip {
    justify-content: space-around;
  }
  .mailbox-detail .message-nav {
    justify-content: space-between;
  }
  .mailbox-detail .icon {
    cursor: pointer;
  }
</style>
